import { gql } from '@/shared/graphql/generated/lp';

export const getStrategiesBalanceChanges = gql(/* GraphQL */ `
  query getStrategiesBalanceChanges($idSs58s: [String!]!) {
    account: allAccounts(filter: { idSs58: { in: $idSs58s } }) {
      nodes {
        idSs58
        strategy: tradingStrategiesByStrategyAccountId {
          nodes {
            baseAsset
            quoteAsset
            owner: accountByOwnerAccountId {
              idSs58
            }
            balanceChangeEvents: tradingStrategyBalanceChangeEventsByTradingStrategyId(
              orderBy: EVENT_ID_DESC
            ) {
              nodes {
                asset
                amountUsd
                amount
                event: eventByEventId {
                  block
                  indexInBlock
                  timestamp
                }
                type
              }
            }
          }
        }
      }
    }
  }
`);
